import { FC, useEffect, useState } from 'react';

export const DEFAULT_THRESHOLD = 250;

/**
 * Shows a loading indicator after the given threshold.
 * @param threshold The time in milliseconds to wait before showing the loading indicator.
 **/

export const DebounceLoadingState: FC<{ threshold?: number }> = ({
  threshold = DEFAULT_THRESHOLD,
  children: loadingIndicator,
}) => {
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowLoadingIndicator(true), threshold);
    return () => clearTimeout(timer);
  }, [threshold]);

  if (!showLoadingIndicator) {
    return null;
  }

  return <>{loadingIndicator}</>;
};
